import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Creates a debounced version of a function
 * @param func The function to debounce
 * @param wait Wait time in ms
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): {
  (...args: Parameters<T>): void;
  flush: () => void;
  cancel: () => void;
} {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let lastArgs: Parameters<T> | null = null;
  
  function debouncedFn(...args: Parameters<T>): void {
    lastArgs = args;
    
    if (timeout) {
      clearTimeout(timeout);
    }
    
    timeout = setTimeout(() => {
      if (lastArgs) {
        func(...lastArgs);
      }
      timeout = null;
      lastArgs = null;
    }, wait);
  }
  
  debouncedFn.flush = function() {
    if (timeout && lastArgs) {
      func(...lastArgs);
      clearTimeout(timeout);
      timeout = null;
      lastArgs = null;
    }
  };
  
  debouncedFn.cancel = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
      lastArgs = null;
    }
  };
  
  return debouncedFn;
}

export function formatCurrency(amount: number, currency: string = 'SAR'): string {
  return `${amount.toLocaleString()} ${currency}`;
}
